import React from "react";
import { AppConfig } from "../common/constants";
import FatalErrorOfflinePage from "./FatalErrorOfflinePage";
import FatalErrorCloudPage from "./FatalErrorCloudPage";

export interface IProps {
  /**
   * httpステータスコード
   */
  status: number | undefined;
  /**
   * ログアウトボタンが押された場合に呼び出されます。
   */
  onLogout?: () => void;
}

export default function FatalErrorPage(props: IProps): JSX.Element {
  const { status, onLogout } = props;

  function getScreen() {
    switch (AppConfig.MODE) {
      case AppConfig.MODE_OFFLINE:
        return <FatalErrorOfflinePage status={status} />;
      case AppConfig.MODE_CLOUD:
        return <FatalErrorCloudPage status={status} onLogout={onLogout} />;
      default:
        return <div>Error</div>;
    }
  }
  return getScreen();
}
